import React from 'react'
import { IonCol, IonItem, IonLabel, IonRow, IonToggle } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import { IOption } from '../../../../../common/common.types'
import { useDispatch, useSelector } from 'react-redux'
import { getBurnsOptionsSelector } from '../../../../options/selectors'
import {
  setBurnType,
  setCarbonInMouth,
  setCoLevel,
  setPoorVentilation,
  setSingedNasalHair,
  saveBurns,
} from '../store/burns.actions'
import { getBurnsSelector } from '../selectors'
import SingleSelect from '../../../../../components/singleSelect/SingleSelect.component'
import NumberPad from '../../../../../components/numberPad/NumberPad.component'
import { numberPadKeysWithDecimal } from '../../../../../components/numberPad/NumberPad.types'

const AdditionalBurns = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const burnsOptions = useSelector(getBurnsOptionsSelector)
  const { burnTypeOptions } = burnsOptions

  const burnsStateData = useSelector(getBurnsSelector)
  const { burnType, singedNasalHair, carbonInMouth, poorVentilation, coLevel } =
    burnsStateData.additionalBurnInformation

  const handleLevelOfConsciousnessChange = (option: IOption) => {
    dispatch(setBurnType(option))
    dispatch(saveBurns())
  }

  const handleSingedNasalHair = (ele: CustomEvent) => {
    let checked = 0
    if (ele?.detail?.checked) {
      checked = 1
    }
    dispatch(setSingedNasalHair(checked))
    dispatch(saveBurns())
  }

  const handleCarbonInMouth = (ele: CustomEvent) => {
    let checked = 0
    if (ele?.detail?.checked) {
      checked = 1
    }
    dispatch(setCarbonInMouth(checked))
    dispatch(saveBurns())
  }

  const handlePoorVentilation = (ele: CustomEvent) => {
    let checked = 0
    if (ele?.detail?.checked) {
      checked = 1
    }
    dispatch(setPoorVentilation(checked))
    dispatch(saveBurns())
  }

  const handleCoLevelOnChange = (numbers: string[]) => {
    const value = numbers.join('')
    dispatch(setCoLevel(value))
    dispatch(saveBurns())
  }

  return (
    <IonRow>
      <IonCol>
        <SingleSelect
          dataTestID='burnType'
          selectedOption={burnType}
          listHeader={t('burns.additionalBurnInformation.BurnType')}
          label={t('burns.additionalBurnInformation.BurnType')}
          options={burnTypeOptions}
          action={handleLevelOfConsciousnessChange}
        />
        <hr className='field-divider' />
        <IonItem lines='none'>
          <IonLabel>
            <div className='toggle-button'>
              <span>{t('burns.additionalBurnInformation.SingedNasalHair')}</span>
            </div>
          </IonLabel>
          <IonToggle
            slot='start'
            name='SingedNasalHair'
            color='zoll-blue-secondary'
            checked={Boolean(singedNasalHair)}
            onIonChange={handleSingedNasalHair}
          />
        </IonItem>
        <IonItem lines='none'>
          <IonLabel>
            <div className='toggle-button'>
              <span>{t('burns.additionalBurnInformation.CarbonInMouth')}</span>
            </div>
          </IonLabel>
          <IonToggle
            slot='start'
            name='CarbonInMouth'
            color='zoll-blue-secondary'
            checked={Boolean(carbonInMouth)}
            onIonChange={handleCarbonInMouth}
          />
        </IonItem>
        <IonItem lines='none'>
          <IonLabel>
            <div className='toggle-button'>
              <span>{t('burns.additionalBurnInformation.PoorVentilation')}</span>
            </div>
          </IonLabel>
          <IonToggle
            slot='start'
            name='PoorVentilation'
            color='zoll-blue-secondary'
            checked={Boolean(poorVentilation)}
            onIonChange={handlePoorVentilation}
          />
        </IonItem>
        <IonRow>
          <IonCol className='picklist'>
            <NumberPad
              isPHI
              elementId={t('burns.additionalBurnInformation.COLevel')}
              dataTestId={t('burns.additionalBurnInformation.COLevel')}
              values={coLevel ? coLevel.toString().split('') : []}
              label={t('burns.additionalBurnInformation.COLevel')}
              onNumPadClick={handleCoLevelOnChange}
              validCharacters={numberPadKeysWithDecimal}
            />
          </IonCol>
        </IonRow>
        <hr className='field-divider' />
      </IonCol>
    </IonRow>
  )
}

export default AdditionalBurns
